<template>
<div>
  <v-app-bar color="blue accent-1" >
      <v-app-bar-nav-icon color="white" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">Hana's English</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn outlined small>Login</v-btn> -->
  </v-app-bar>
    <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    >
      <sideBar @setSubCategory="setSubCategory"/>
    </v-navigation-drawer>
  <v-container>
    <v-row>
      <v-col>
          <!-- 검색 바 -->
          <v-text-field
          label="search"
          v-model="searchTerm"
          @keyup.enter="searchBooks"   
          >
            <template v-slot:append>
              <v-icon @click="searchBooks">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>
    </v-row>
    <v-card class="pa-3">
      <template v-if="book_list.length==0">
        <v-card-text class="text-center">
          <v-card-subtitle>
            검색 되는 책이 없습니다.
          </v-card-subtitle>
        </v-card-text>
        
      </template>
      <v-row>
        <v-col
          v-for="book in book_list"
          :key="book.id"
          class="d-flex child-flex"
          cols="12" md="3" lg="3"
        >
          <v-card
            class="mx-auto"
            outlined
            @click="setBook(book)"
          >
            <v-img
              :src="$store.state.backend_url+book.image"
              class="ma-2"
            ></v-img>

            <v-card-subtitle>
              {{ book.title }}
            </v-card-subtitle>

          </v-card>
        </v-col>
      </v-row>
      <div class="text-center mt-2">
        <v-pagination
          v-model="page"
          :length="10"
          circle
        ></v-pagination>
      </div>
    </v-card>
    <v-dialog v-model="show_book_view" max-width="800px">
      <v-card outlined class="pa-1">
        <v-card-text>
          <bookView :set_book="set_book"/>
        </v-card-text>
        <v-card-actions>
          <v-btn block outlined  @click="show_book_view=!show_book_view">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>   
  </v-container>
</div>
</template>

<script>
  import bookView  from '@/components/bookView.vue'
  import sideBar from '@/components/sideBar.vue'
  import axios from 'axios'

  export default {
    data: () => ({
      drawer: false,
      show_book_view: false,
      page: 1,

      category_title: 'Total',
      sub_category : {},
      sub_category_id : 0,
      
      book_list :[],
      set_book: {},
      searchTerm: ''
    }),
  
    watch:{

    },

    components: {
      bookView,
      sideBar,
    },

    mounted(){
      this.getBooks()
    },
    methods:{
      setSubCategory(sub_category){
        this.drawer = false
        this.sub_category = sub_category
        this.sub_category_id = sub_category.id
        this.category_title = sub_category.name
      },

      getBooks(){
        axios
        .get(`api/post/get-books/?page=${this.page}`)
        .then(res=>{
          this.book_list = res.data.results
        })
        .catch(err=>{
          console.log('book가 더 없습니다.')
        })
      },

      searchBooks(){
        console.log(this.searchTerm)
        axios
        .get(`api/post/search-books/?search=${this.searchTerm}`)
        .then(res=>{
          this.book_list = res.data.results
        })
        .catch(err=>{
          console.log('book가 더 없습니다.')
        })
      },

      setBook(book){
        this.show_book_view = true
        this.set_book = book
      },

      formatDate(dateTimeString) {
          if(dateTimeString==null){
          } else {
              const dateTime = new Date(dateTimeString);
              // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              const options = { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              return dateTime.toLocaleString(undefined, options);
          }
	      },  
      },
      computed:{
        formattedDateTimes() {
          return this.dateTimeStrings.map((dateTimeString) => this.formatDate(dateTimeString));
          },
      }
  }
</script>
